__turbopack_context__.v({
  "customErrorPage": "view-module__qVYRSG__customErrorPage",
  "customErrorPageDiv": "view-module__qVYRSG__customErrorPageDiv",
  "errorHero": "view-module__qVYRSG__errorHero",
  "errorPageMainContent": "view-module__qVYRSG__errorPageMainContent",
  "errorSubtitle": "view-module__qVYRSG__errorSubtitle",
});
